import React from 'react';
import Titulo from './Titulo';
import Subtitulo from './Subtitulo';
import Mancheta from './Mancheta';
import { colors } from '../utils/colors';


class Intro extends React.Component {
  render() {
    return (
  <div
  className="intro"
  style={{
					color: 'black',
					width: `${this.props.windowWidth}px`,
					height: `${this.props.windowHeight}px`,
					margin: '0 auto',
					background: 'url(./img/intro.jpg)  no-repeat bottom',
					backgroundSize: 'cover',
					padding: '0',
				}}
			>
  <Mancheta joly={this.props.joly}
				/>

  <Titulo contenido="CAMINITO DE JEREZ" />
  <p style={{ color: `${colors.white}`,}}
				>POR JESÚS BENÍTEZ
    </p>
  <Subtitulo contenido="Cuatro aviones Boeing 747 transportan ya desde Estados Unidos a España todas las motos y logística de MotoGP para el Gran Premio del 6 de mayo en el circuito andaluz" />

			</div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/components/Intro.js